/** What the planning wait shows (components/changes/Zacking.tsx): its facts and how its bar moves. */

/** Things about Zoom to read while ZAC is zacking: each one true, none about the person's own account. */
export const ZOOM_FACTS = [
  'Zoom was founded in 2011 by Eric Yuan, who had been an engineer on Cisco Webex.',
  'Zoom went public on Nasdaq in April 2019, under the ticker ZM.',
  'In April 2020 Zoom reported more than 300 million daily meeting participants, up from about 10 million in December 2019.',
  'Zoom Phone, the cloud phone system ZAC is setting up for you, launched in 2019.',
  'A Zoom Phone call queue can ring its members all at once, one after another, in rotation, or the longest idle first.',
  "Wrap-up time gives a queue's members a breather after each call before the next one reaches them.",
  "A queue's closed hours can send callers straight to voicemail, to another extension, or to an auto receptionist.",
  'Zoom Contact Center launched in 2022, for teams that need routing, skills and analytics beyond a call queue.',
  'Zoom renamed its platform Zoom Workplace in 2024: meetings, chat, phone, whiteboard and docs in one app.',
  'Zoom AI Companion arrived in 2023, included with paid Zoom accounts at no extra cost.',
  'ZAC talks to your account through a Server-to-Server OAuth app: it acts for the account, no one has to sign in each time.',
  'Zoom is headquartered in San Jose, California.',
  'Every Zoom Phone user has an extension, and a calling plan is what lets them call outside the company.',
];

/** How far along a stage looks after `elapsed`: rising quickly, then slowly, never full until it is done. Pure. */
export function progressOf(elapsed: number, expected: number): number {
  return Math.min(95, Math.round(100 * (1 - Math.exp(-Math.max(0, elapsed) / expected))));
}
